module.exports = __webpack_public_path__ + "img/xeno-2.bc0ebae6.jpg";